import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import hotelList from '../utils/hotels';
import { isEmptyObject } from '../utils';

function useHotel() {
  const { hotel } = useSelector((state) => state.checking);
  const [dataHotel, setDataHotel] = useState({});

  useEffect(() => {
    if (hotel !== '') {
      const hotelObject = hotelList.find((item) => item.HotelId === hotel);
      if (!isEmptyObject(hotelObject)) {
        setDataHotel(hotelObject);
      }
    }
  }, [setDataHotel, hotel]);

  return { dataHotel };
}

export default useHotel;
